export const VOLUME_TREGU = [
	{ price: 0.85, id: 157, number: 1, from: 0, to: 50000, zoneId: 1 },
	{ price: 1.35, id: 158, number: 2, from: 50000, to: 100000, zoneId: 1 },
	{ price: 1.8, id: 159, number: 3, from: 100000, to: 200000, zoneId: 1 },
	{ price: 2.35, id: 160, number: 4, from: 200000, to: 300000, zoneId: 1 },
	{ price: 3.5, id: 161, number: 5, from: 300000, to: 400000, zoneId: 1 },
	{ price: 5, id: 162, number: 6, from: 400000, to: 500000, zoneId: 1 },
	{ price: 7, id: 163, number: 7, from: 500000, to: 600000, zoneId: 1 },
	{ price: 9, id: 164, number: 8, from: 600000, to: 700000, zoneId: 1 },
	{ price: 11, id: 165, number: 9, from: 700000, to: null, zoneId: 1 },
	{ price: 2.35, id: 166, number: 1, from: 0, to: 50000, zoneId: 2 },
	{ price: 5.85, id: 167, number: 2, from: 50000, to: 100000, zoneId: 2 },
	{ price: 11.5, id: 168, number: 3, from: 100000, to: 200000, zoneId: 2 },
	{ price: 17.5, id: 169, number: 4, from: 200000, to: 300000, zoneId: 2 },
	{ price: 26.5, id: 170, number: 5, from: 300000, to: 400000, zoneId: 2 },
	{ price: 30, id: 171, number: 6, from: 400000, to: 500000, zoneId: 2 },
	{ price: 36, id: 172, number: 7, from: 500000, to: 600000, zoneId: 2 },
	{ price: 41, id: 173, number: 8, from: 600000, to: 700000, zoneId: 2 },
	{ price: 45, id: 174, number: 9, from: 700000, to: null, zoneId: 2 },
	{ price: 2.35, id: 166, number: 1, from: 0, to: 50000, zoneId: 3 },
	{ price: 5.85, id: 167, number: 2, from: 50000, to: 100000, zoneId: 3 },
	{ price: 11.5, id: 168, number: 3, from: 100000, to: 200000, zoneId: 3 },
	{ price: 17.5, id: 169, number: 4, from: 200000, to: 300000, zoneId: 3 },
	{ price: 26.5, id: 170, number: 5, from: 300000, to: 400000, zoneId: 3 },
	{ price: 30, id: 171, number: 6, from: 400000, to: 500000, zoneId: 3 },
	{ price: 36, id: 172, number: 7, from: 500000, to: 600000, zoneId: 3 },
	{ price: 41, id: 173, number: 8, from: 600000, to: 700000, zoneId: 3 },
	{ price: 45, id: 174, number: 9, from: 700000, to: null, zoneId: 3 },
];

export const WEIGHT_TREGU = [
	{ price: 0.85, id: 130, number: 1, from: 0, to: 5, zoneId: 1 },
	{ price: 1.35, id: 131, number: 2, from: 5, to: 10, zoneId: 1 },
	{ price: 1.85, id: 132, number: 3, from: 10, to: 15, zoneId: 1 },
	{ price: 2.85, id: 133, number: 4, from: 15, to: 20, zoneId: 1 },
	{ price: 3.85, id: 134, number: 5, from: 20, to: 25, zoneId: 1 },
	{ price: 4.85, id: 135, number: 6, from: 25, to: 30, zoneId: 1 },
	{ price: 8, id: 136, number: 7, from: 30, to: null, zoneId: 1 },
	{ price: 2.35, id: 137, number: 1, from: 0, to: 5, zoneId: 2 },
	{ price: 6.35, id: 138, number: 2, from: 5, to: 10, zoneId: 2 },
	{ price: 10.5, id: 139, number: 3, from: 10, to: 15, zoneId: 2 },
	{ price: 15.5, id: 140, number: 4, from: 15, to: 20, zoneId: 2 },
	{ price: 21.5, id: 141, number: 5, from: 20, to: 25, zoneId: 2 },
	{ price: 27.5, id: 142, number: 6, from: 25, to: 30, zoneId: 2 },
	{ price: 40, id: 143, number: 7, from: 30, to: null, zoneId: 2 },
	{ price: 2.35, id: 137, number: 1, from: 0, to: 5, zoneId: 3 },
	{ price: 6.35, id: 138, number: 2, from: 5, to: 10, zoneId: 3 },
	{ price: 10.5, id: 139, number: 3, from: 10, to: 15, zoneId: 3 },
	{ price: 15.5, id: 140, number: 4, from: 15, to: 20, zoneId: 3 },
	{ price: 21.5, id: 141, number: 5, from: 20, to: 25, zoneId: 3 },
	{ price: 27.5, id: 142, number: 6, from: 25, to: 30, zoneId: 3 },
	{ price: 40, id: 143, number: 7, from: 30, to: null, zoneId: 3 },
];

export const VALUE_TREGU = [
	{ percentage: 0, id: 54, number: 1, from: 0, to: 200, zoneId: 1 },
	{ percentage: 0, id: 55, number: 2, from: 200, to: 300, zoneId: 1 },
	{ percentage: 0, id: 56, number: 3, from: 300, to: 400, zoneId: 1 },
	{ percentage: 0, id: 57, number: 4, from: 400, to: 500, zoneId: 1 },
	{ percentage: 2, id: 58, number: 5, from: 500, to: 600, zoneId: 1 },
	{ percentage: 2.5, id: 59, number: 6, from: 600, to: 1000, zoneId: 1 },
	{ percentage: 3, id: 60, number: 7, from: 1000, to: 3000, zoneId: 1 },
	{ percentage: 3.5, id: 61, number: 8, from: 3000, to: null, zoneId: 1 },
	{ percentage: 0, id: 62, number: 1, from: 0, to: 200, zoneId: 2 },
	{ percentage: 0, id: 63, number: 2, from: 200, to: 300, zoneId: 2 },
	{ percentage: 4, id: 64, number: 3, from: 300, to: 400, zoneId: 2 },
	{ percentage: 4.5, id: 65, number: 4, from: 400, to: 500, zoneId: 2 },
	{ percentage: 5, id: 66, number: 5, from: 500, to: 600, zoneId: 2 },
	{ percentage: 5, id: 67, number: 6, from: 600, to: 1000, zoneId: 2 },
	{ percentage: 5.5, id: 68, number: 7, from: 1000, to: 3000, zoneId: 2 },
	{ percentage: 6, id: 69, number: 8, from: 3000, to: null, zoneId: 2 },
	{ percentage: 0, id: 62, number: 1, from: 0, to: 200, zoneId: 3 },
	{ percentage: 0, id: 63, number: 2, from: 200, to: 300, zoneId: 3 },
	{ percentage: 4, id: 64, number: 3, from: 300, to: 400, zoneId: 3 },
	{ percentage: 4.5, id: 65, number: 4, from: 400, to: 500, zoneId: 3 },
	{ percentage: 5, id: 66, number: 5, from: 500, to: 600, zoneId: 3 },
	{ percentage: 5, id: 67, number: 6, from: 600, to: 1000, zoneId: 3 },
	{ percentage: 5.5, id: 68, number: 7, from: 1000, to: 3000, zoneId: 3 },
	{ percentage: 6, id: 69, number: 8, from: 3000, to: null, zoneId: 3 },
];
